import React from 'react';
import { motion } from 'framer-motion';
import { StarIcon, ShieldCheckIcon, CreditCardIcon, ZapIcon, ClockIcon } from 'lucide-react';
import { CTAButton } from './CTAButton';
export function PricingCard() {
  return <section id="pricing" className="py-10 sm:py-14 px-4 relative scroll-mt-10" data-id="element-186">
      <div className="absolute inset-0 bg-brand-orange/10 blur-[150px] rounded-full max-w-3xl mx-auto" data-id="element-187" />

      <div className="max-w-md sm:max-w-lg mx-auto relative z-10" data-id="element-188">
        <motion.h2 initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} className="text-3xl sm:text-4xl font-black text-center mb-6 text-brand-cream" data-id="element-189">
          L'Offerta "Programmazione Pronta"
        </motion.h2>

        <motion.div initial={{
        opacity: 0,
        scale: 0.95
      }} whileInView={{
        opacity: 1,
        scale: 1
      }} viewport={{
        once: true
      }} className="bg-gradient-to-b from-[#1a0f0a] to-[#120a06] border border-brand-orange/40 rounded-3xl relative shadow-[0_0_50px_rgba(249,115,22,0.15)]" data-id="element-190">
          {/* Badge */}
          <div className="flex justify-center -mt-4 mb-2" data-id="element-191">
            <div className="bg-gradient-to-b from-brand-gold to-amber-500 text-black font-black px-5 py-1.5 rounded-full flex items-center gap-1.5 uppercase tracking-wide text-xs shadow-[0_0_20px_rgba(251,191,36,0.5)]" data-id="element-192">
              <StarIcon className="w-3.5 h-3.5 fill-current" data-id="element-193" />
              LA SCELTA PIÙ POPOLARE
            </div>
          </div>

          <div className="p-6 sm:p-8" data-id="element-194">
            <h3 className="text-base sm:text-lg font-black text-center text-brand-cream uppercase mb-6 leading-tight" data-id="element-195">
              VALORE TOTALE DEI CONTENUTI:
            </h3>

            <div className="space-y-0 mb-5" data-id="element-196">
              {[{
              label: '6 Volumi Completi Biennio e Triennio',
              price: '197 €'
            }, {
              label: 'Soluzionari e Materiale LIM',
              price: '67 €'
            }, {
              label: 'Manuale Recupero e Inclusione DSA e BES',
              price: '57 €'
            }, {
              label: '4 Bonus Esclusivi',
              price: '56 €'
            }].map((item, i) => <div key={i} className="flex justify-between items-center border-b border-white/10 py-3 gap-3" data-id="element-197">
                  <span className="text-gray-300 font-medium text-xs sm:text-sm" data-id="element-198">
                    {item.label}
                  </span>
                  <span className="text-gray-500 line-through text-sm shrink-0" data-id="element-199">
                    {item.price}
                  </span>
                </div>)}
              <div className="flex justify-between items-center pt-4" data-id="element-200">
                <span className="text-sm sm:text-base font-black text-brand-cream uppercase" data-id="element-201">
                  VALORE REALE:
                </span>
                <span className="text-xl sm:text-2xl font-black text-brand-danger line-through" data-id="element-202">
                  377,00 €
                </span>
              </div>
            </div>

            {/* Discount badge */}
            <div className="flex justify-center mb-4" data-id="element-203">
              <div className="bg-brand-danger/20 border border-brand-danger/40 text-brand-danger font-black px-4 py-1.5 rounded-full text-xs uppercase tracking-wide" data-id="element-204">
                95% di sconto — Offerta Lancio
              </div>
            </div>

            {/* Inner offer card */}
            <div className="bg-[#1f110a] border border-brand-orange/40 rounded-2xl p-5 text-center mb-5" data-id="element-205">
              <div className="flex justify-center items-center gap-2 mb-2" data-id="element-206">
                <span className="text-3xl" data-id="element-207">🏆</span>
                <span className="text-4xl sm:text-5xl font-black text-brand-cream" data-id="element-208">
                  27,90 €
                </span>
              </div>
              <p className="text-xs text-gray-300 mt-2 font-medium" data-id="element-209">
                💳 Pagamento unico • ⚡ Accesso immediato
              </p>
            </div>

            {/* Salirà presto pill */}
            <div className="flex justify-center mb-5" data-id="element-210">
              <div className="inline-flex items-center gap-2 border border-brand-orange/40 bg-brand-orange/5 px-4 py-1.5 rounded-full" data-id="element-211">
                <ClockIcon className="w-4 h-4 text-brand-orange" data-id="element-212" />
                <span className="text-xs font-bold text-brand-orange" data-id="element-213">
                  Prezzo speciale di lancio — salirà a breve.
                </span>
              </div>
            </div>

            <CTAButton href="https://italia.kitonline.shop/cart/44562278973575:1" className="w-full mb-5" data-id="element-214">
              SÌ! VOGLIO IL KIT COMPLETO
            </CTAButton>

            <div className="flex flex-wrap justify-center items-center gap-x-3 gap-y-1 text-[11px] sm:text-xs text-gray-400 font-medium" data-id="element-215">
              <span className="flex items-center gap-1" data-id="element-216">
                <ZapIcon className="w-3 h-3 text-brand-gold" data-id="element-217" /> Accesso
                immediato
              </span>
              <span className="text-gray-600" data-id="element-218">•</span>
              <span className="flex items-center gap-1" data-id="element-219">
                <CreditCardIcon className="w-3 h-3 text-brand-gold" data-id="element-220" /> Un solo
                Pagamento
              </span>
              <span className="text-gray-600" data-id="element-221">•</span>
              <span className="flex items-center gap-1" data-id="element-222">
                <ShieldCheckIcon className="w-3 h-3 text-brand-gold" data-id="element-223" /> Garanzia
                di 14 giorni
              </span>
            </div>
          </div>
        </motion.div>
      </div>
    </section>;
}